import React from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { useEffect, useState } from "react";
import "react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
import {
  getPaymentTypes,
  getTransItems,
  multiActionBy,
  multiDeleteApi,
  multiDeleteInvoices,
  updateAndRemove,
  updateBeatName,
  updateUnitRowApi,
} from "../../util/APIUtils";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import SalesItemsBody from "./SalesItemsBody";
import SalesItemsHeadBody from "./SalesItemsHeadBody";
import swal from "sweetalert";
import ModalFullscreenExample from "./ModalFullscreenExample";
import { LoadingOverlay } from "../../util/Helpers";
import ReceivePaymentBody from "./ReceivePaymentBody";
import SalesPartyDetails from "./SalesPartyDetails";

const options = {
  sortIndicator: true,
  hideSizePerPage: false,
  paginationSize: 3,
  hidePageListOnlyOnePage: false,
  clearSearch: true,
  alwaysShowAllBtns: true,
  withFirstAndLast: true,
};
const statusType = {
  PAID: "PAID",
  NOT_PAID: "NOT PAID",
  PARTIALLY_PAID: "PARTIALLY PAID",
  CANCELLED: "CANCELLED",
  CHEQUE_DEPOSITED: "CHEQUE DEPOSITED",
  CHEQUE_RECEIVED: "CHEQUE RECEIVED",
  ECHO: "ECHO",
  DUMP: "DUMP",
  unKnow: "UnKnow",
};

export default function SalesSummeryBody({
  data,
  onHide,
  datahandler,
  cancelInvoice,
  paymntDetails,
  getInvoiceHistory,
  mFlag,
  onMflag,
  getInvoiceSoftCopy,
  getPartyHistory,
  partyDetails
}) {
  // const [values, setValues] = useState([]);
  const [flag, setFlag] = useState("1");
  const [headValues, setHeadValues] = useState({});
  const [block, setBlock] = useState(false);
  const [editable, setEditable] = useState(true);
  const [modal, setModal] = useState(false);
  const [opts, setOpts] = useState([]);
  const [contextMenuOpen, setContextMenuOpen] = useState(false);
  const [contextMenuPosition, setContextMenuPosition] = useState({
    x: 0,
    y: 0,
  });
  const [currentRow, setCurrentRow] = useState({});
  const [footValues, setFootValues] = useState({});
  const [selectedRows, setSelectedRows] = useState([])
  const [selectedInvoiceRows, setSelectedInvoiceRows] = useState([])


  const handleRightClick = (e, row) => {
    e.preventDefault();
    setContextMenuPosition({ x: e.clientX, y: e.clientY });
    setContextMenuOpen(true);
    setCurrentRow(row);
  };

  const handleMenuItemClick = (action, row) => {
    if (action == 1) {
      let obj = { invoiceNumber: row.invoiceNumber };
      setContextMenuOpen(false);
      cancelInvoice(obj);
    } else if (action == 2) {
      let obj = { billNumber: row.invoiceNumber };
      setContextMenuOpen(false);
      getInvoiceHistory(obj);
    } else if (action == 3) {
      let obj = { invoiceNum: row.invoiceNumber };
      getInvoiceSoftCopy(obj);
    } else if (action == 4) {
      swal({
        text: `Enter new Beat Name (Current: ${row.beatName}):`,
        content: "input",
        button: {
          text: "Update",
          closeModal: false,
        },
      })
        .then((newBeatName) => {
          if (!newBeatName) throw null;

          let updatedRow = { ...row, beatName: newBeatName };
          return updateBeatName(updatedRow);
        })
        .then((response) => {
          if (response) {
            swal("Success", "Beat Name updated successfully!", "success");
            datahandler(); // Refresh data
          }
        })
        .catch((err) => {
          if (err) {
            swal("Error", "Failed to update Beat Name!", "error");
          } else {
            swal.stopLoading();
            swal.close();
          }
        });
    } else if (action == 5) {
      let hulCode = row.hulCode;
      setContextMenuOpen(false);
      getPartyHistory(hulCode);
    }
  };

  const enumFormatter = (cell, row, enumObject) => {
    return enumObject[cell];
  };
  const cellButton = (cell, row, enumObject, rowIndex) => {
    return (
      <span>
        <Button
          className="btn btn-info btn-sm"
          id={"edit" + rowIndex}
          onClick={(e) => handleClickEdit(row)}
          text="View invoice details"
        >
          <i className="fa fa-info-circle" />
        </Button>
        <Button
          className="btn btn-danger btn-sm"
          id={"collect" + rowIndex}
          onClick={(e) => handleClickPayment(row)}
          style={{ marginLeft: "5px" }}
          text="Collect Payment"
        >
          <i className="fa fa-inr" />
        </Button>
        <Button
          className="btn btn-warning btn-sm"
          id={"more" + rowIndex}
          onClick={(e) => handleRightClick(e, row)}
          style={{ marginLeft: "5px" }}
          text="More Options"
        >
          <i className="fa fa-ellipsis-v" />
        </Button>
      </span>
    );
  };
  const handleClickPayment = (row) => {
    setHeadValues(row);
    toggle();
  };
  const toggle = () => setModal(!modal);
  const handleClickEdit = (row) => {
    //setFlag("2");
    //onHide();
    onMflag("2");
    setHeadValues(row);
    let obj = { billNumber: row.invoiceNumber };
    loadReqData(obj);
  };
  const handleEditable = () => {
    setEditable(!editable);
  };
  const handleBack = () => {
    //setFlag("1");
    // onHide();
    onMflag("1");
    setEditable(true);
  };
  useEffect(() => {
    // if (typeof data !== "undefined" && data.length > 0) {
    //   setValues(data);
    // }
    loadOptions();
  }, []);

  const loadOptions = () => {
    getPaymentTypes().then((response) => {
      setOpts(response);
    });
  };

  const loadReqData = (obj) => {
    setBlock(true);
    getTransItems(obj).then((response) => {
      setFootValues(response);
      setBlock(false);
    });
  };

  const updateUnitRow = (row) => {
    let obj = { billNumber: row.invoiceNumber };
    setBlock(true);
    updateUnitRowApi(row).then((response) => {
      loadReqData(obj);
      swal({
        text: "Updated Succesfully",
      });
      setBlock(false);
    });
  };

  const handleDeleteAction = (row) => {
    const allRules = Object.assign({}, row, headValues);
    allRules.action = "delete";
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this item!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setBlock(true);
        updateAndRemove(allRules).then((response) => {
          delete response.saleItems;
          setHeadValues(response);
          swal({
            text: "Deleted Succesfully",
          });
          let obj = { billNumber: response.invoiceNumber };
          loadReqData(obj);
          setBlock(false);
        });
      };
    });
  };


  const handleAfterSaveCell = (row, cellName, cellValue) => {
    setBlock(true);
    row.action = "update";
    updateAndRemove(row).then((response) => {
      setHeadValues(response);
      swal({
        text: "Updated Succesfully",
      });
      let obj = { billNumber: response.invoiceNumber };
      loadReqData(obj);
    });

    setBlock(false);
  };

  const onUpdateHeadMap = () => {
    setBlock(!block);
    headValues.action = "update";
    updateAndRemove(headValues).then((response) => {
      setHeadValues(response);
    });
    setBlock(!block);
    setEditable(!editable);
  };

  const onChangeHeadMap = ({ target }) => {
    const { name, value } = target;
    setHeadValues((previousState) => ({
      ...previousState,
      [name]: value,
    }));
  };




  const onRowSelect = (row, isSelected, e) => {
    setSelectedInvoiceRows(rows => {
      if (isSelected) {
        return [...rows, row.id];
      } else {
        return rows.filter(id => id !== row.id);
      }
    });
  }

  const onSelectAll = (isSelected, rows) => {
    setSelectedInvoiceRows(isSelected ? rows.map(r => r.id) : []);
  }

  const selectRowProp = {
    mode: 'checkbox',
    //   clickToSelect: true,
    onSelect: onRowSelect,
    onSelectAll: onSelectAll
  };
  // Custom styles for the Delete button
  const deleteBtnStyle = {
    backgroundColor: "#e74c3c",
    borderColor: "#e74c3c",
    color: "#fff",
    fontWeight: "bold",
    letterSpacing: "0.5px",
    padding: "8px 20px",
    borderRadius: "4px",
    boxShadow: "0 2px 6px rgba(231,76,60,0.15)",
    marginBottom: "15px"
  };


  const sendSelectedInvoiceRows = () => {
    if (selectedInvoiceRows.length === 0) {
      swal("No rows selected", "Please select at least one row.", "warning");
      return;
    } else {
      //using swal show confirm dialog
      swal({
        title: "Are you sure?",
        text: `You are about to delete ${selectedInvoiceRows.length} selected rows.`,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          setBlock(true);
          multiDeleteInvoices(selectedInvoiceRows).then((response) => {
            swal("Success", "Selected rows deleted successfully!", "success");
            datahandler(); // Refresh data
            setSelectedInvoiceRows([]);
            setBlock(false);
          });
        }
      }
      );
    }

  };

  // bulk-delete for items inside an invoice (called from SalesItemsBody)
  const sendSelectedRows = () => {
    if (selectedRows.length === 0) {
      swal("No rows selected", "Please select at least one row.", "warning");
      return;
    }

    swal({
      title: "Are you sure?",
      text: `You are about to delete ${selectedRows.length} selected item${selectedRows.length > 1 ? "s" : ""}.`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setBlock(true);
        multiDeleteApi(selectedRows).then((response) => {
          swal("Success", "Selected items deleted successfully!", "success");
          // refresh current invoice details
          const obj = { billNumber: headValues.invoiceNumber };
          loadReqData(obj);
          setSelectedRows([]);
          setBlock(false);
        });
      }
    });
  };
  const sendActionBybtn = (action) => {
    if (selectedInvoiceRows.length === 0) {
      swal("No rows selected", "Please select at least one row.", "warning");
      return;
    } else {
      //using swal show confirm dialog
      swal({
        title: "Are you sure?",
        text: `You are about to ${action} ${selectedInvoiceRows.length} selected rows.`,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          setBlock(true);
          let obj = {
            action: action,
            invoiceIds: selectedInvoiceRows
          }
          multiActionBy(obj).then((response) => {
            swal("Success", `Selected rows ${action} successfully!`, "success");
            datahandler(); // Refresh data
            setSelectedInvoiceRows([]);
            setBlock(false);
          });
        }
      }
      );
    }

  };

  return (
    <span>
      {block && <LoadingOverlay />}
      {mFlag == "3" ? (
        <Card>
          <CardHeader>
            <strong>Invoice History</strong>
          </CardHeader>
          <CardBody>
            <Button
              className="btn btn-info"
              id="back"
              onClick={() => onMflag("1")}
              style={{ marginLeft: "5px", marginBottom: "5px" }}
            >
              <i className="fa fa-arrow-left" />
            </Button>
            <ReceivePaymentBody data={paymntDetails} />
          </CardBody>
        </Card>
      ) : null}
      {mFlag == "4" ? (
        <Card>
          <CardHeader>
            <strong>Party History</strong>
          </CardHeader>
          <CardBody>
            <Button
              className="btn btn-info"
              id="back"
              onClick={() => onMflag("1")}
              style={{ marginLeft: "5px", marginBottom: "5px" }}
            >
              <i className="fa fa-arrow-left" />
            </Button>
            <SalesPartyDetails data={partyDetails} />
          </CardBody>
        </Card>
      ) : null}
      {mFlag == "1" ? (
        <Card>
          <CardBody>
            <ModalFullscreenExample
              OnToggle={toggle}
              view={modal}
              currentRow={headValues}
              options={opts}
              refresh={datahandler}
            />

            <Button
              className="btn"
              style={{
                background: "linear-gradient(135deg, #3498db 0%, #2980b9 100%)",
                border: "none",
                color: "#fff",
                fontWeight: "600",
                padding: "10px 22px",
                borderRadius: "8px",
                boxShadow: "0 4px 15px rgba(52, 152, 219, 0.3)",
                marginRight: "10px",
                marginBottom: "15px",
                transition: "all 0.3s ease",
              }}
              onClick={() => sendActionBybtn("Echo")}
            >
              <i className="fa fa-volume-up" style={{ marginRight: "8px" }} />
              Echo
            </Button>
            <Button
              className="btn"
              style={{
                background: "linear-gradient(135deg, #9b59b6 0%, #8e44ad 100%)",
                border: "none",
                color: "#fff",
                fontWeight: "600",
                padding: "10px 22px",
                borderRadius: "8px",
                boxShadow: "0 4px 15px rgba(155, 89, 182, 0.3)",
                marginRight: "10px",
                marginBottom: "15px",
                transition: "all 0.3s ease",
              }}
              onClick={() => sendActionBybtn("Dump")}
            >
              <i className="fa fa-download" style={{ marginRight: "8px" }} />
              Dump
            </Button>
            <Button
              className="btn"
              style={{
                background: "linear-gradient(135deg, #f39c12 0%, #e67e22 100%)",
                border: "none",
                color: "#fff",
                fontWeight: "600",
                padding: "10px 22px",
                borderRadius: "8px",
                boxShadow: "0 4px 15px rgba(243, 156, 18, 0.3)",
                marginRight: "10px",
                marginBottom: "15px",
                transition: "all 0.3s ease",
              }}
              onClick={sendSelectedInvoiceRows}
            >
              <i className="fa fa-ban" style={{ marginRight: "8px" }} />
              Cancel
            </Button>

            <BootstrapTable
              data={data.salesData}
              version="4"
              condensed={true}
              striped
              hover
              pagination
              search
              options={options}
              exportCSV
              selectRow={selectRowProp}
              csvFileName="sales_summary.csv"
            // selectRow={{
            //   mode: "checkbox", // Enables multi-selection
            //   clickToSelect: true,
            //   bgColor: "lightblue", // Highlight selected rows
            //   onSelect: (row, isSelected) => {
            //     console.log("Row selected:", row, "Selected:", isSelected);

            //   },
            //   onSelectAll: (isSelected, rows) => {
            //     console.log("All rows selected:", isSelected, rows);
            //   },
            // }}
            >
              <TableHeaderColumn
                isKey
                dataField="id"
                export={false}
                hidden={true}
              >
                ID
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="salesPersonName"
                export={true}
                hidden={true}
              >
                ID
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="billDate"
                csvHeader="billDate"
                filter={{ type: "TextFilter", delay: 1000 }}
                dataSort
                tdStyle={{ whiteSpace: "normal" }}
                thStyle={{ whiteSpace: "normal" }}
                editable={true}
              >
                Bill Date
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="invoiceNumber"
                csvHeader="invoiceNumber"
                filter={{ type: "TextFilter", delay: 1000 }}
                dataSort
                tdStyle={{ whiteSpace: "normal" }}
                thStyle={{ whiteSpace: "normal" }}
                editable={true}
              >
                Invoice Number
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="beatName"
                csvHeader="beatName"
                filter={{ type: "TextFilter", delay: 1000 }}
                dataSort
                tdStyle={{ whiteSpace: "normal" }}
                thStyle={{ whiteSpace: "normal" }}
                editable={true}
              >
                Beat Name
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="partyName"
                csvHeader="partyName"
                filter={{ type: "TextFilter", delay: 1000 }}
                dataSort
                tdStyle={{ whiteSpace: "normal" }}
                thStyle={{ whiteSpace: "normal" }}
                editable={true}
              >
                Party Name
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="paymentType"
                csvHeader="paymentType"
                filter={{ type: "TextFilter", delay: 1000 }}
                dataSort
                tdStyle={{ whiteSpace: "normal" }}
                thStyle={{ whiteSpace: "normal" }}
                editable={true}
              >
                Payment Type
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="netSales"
                csvHeader="netSales"
                filter={{ type: "TextFilter", delay: 1000 }}
                dataSort
                tdStyle={{ whiteSpace: "normal" }}
                thStyle={{ whiteSpace: "normal" }}
                editable={true}
              >
                Amount
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="balance"
                csvHeader="balance"
                filter={{ type: "TextFilter", delay: 1000 }}
                dataSort
                tdStyle={{ whiteSpace: "normal" }}
                thStyle={{ whiteSpace: "normal" }}
                editable={true}
              >
                Balance Due
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="status"
                csvHeader="status"
                //  filter={{ type: "TextFilter", delay: 1000 }}
                filterFormatted
                dataFormat={enumFormatter}
                formatExtraData={statusType}
                filter={{
                  type: "SelectFilter",
                  options: statusType,
                  condition: "eq",
                }}
                dataSort
                tdStyle={{ whiteSpace: "normal" }}
                thStyle={{ whiteSpace: "normal" }}
              >
                Status
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="button"
                dataFormat={cellButton}
                hiddenOnInsert
                export={false}
              >
                Actions
              </TableHeaderColumn>
            </BootstrapTable>
            {contextMenuOpen && (
              <Dropdown
                isOpen={contextMenuOpen}
                toggle={() => setContextMenuOpen(false)}
                style={{
                  position: "fixed",
                  top: contextMenuPosition.y,
                  left: contextMenuPosition.x,
                }}
              >
                <DropdownToggle
                  tag="span"
                  data-toggle="dropdown"
                  aria-expanded={true}
                />
                <DropdownMenu>
                  <DropdownItem
                    onClick={() => handleMenuItemClick(1, currentRow)}
                  >
                    Cancel
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => handleMenuItemClick(2, currentRow)}
                  >
                    Invoice History
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => handleMenuItemClick(5, currentRow)}
                  >
                    Party History
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => handleMenuItemClick(3, currentRow)}
                  >
                    Get Invoice
                  </DropdownItem>
                  {localStorage.getItem("access-role") === "ROLE_ADMIN" && (
                    <DropdownItem
                      onClick={() => handleMenuItemClick(4, currentRow)}
                    >
                      Update Beat Name
                    </DropdownItem>)}
                </DropdownMenu>
              </Dropdown>
            )}
          </CardBody>
        </Card>
      ) : null}
      {mFlag == "2" ? (
        <span>
          <SalesItemsHeadBody
            onChangeHead={onChangeHeadMap}
            headValues={headValues}
            flag={editable}
            handleEditable={handleEditable}
            onUpdateHead={onUpdateHeadMap}
            handleBack={handleBack}
            options={opts}
          />
          <SalesItemsBody
            deleteClick={handleDeleteAction}
            saveEditCell={handleAfterSaveCell}
            wait={block}
            footValues={footValues}
            handleSelectedRows={setSelectedRows}
            sendSelectedRows={sendSelectedRows}
            loadData={loadReqData}
            updateUnitRow={updateUnitRow}
          />
        </span>
      ) : null}
    </span>
  );
}



// WEBPACK FOOTER //
// ./src/components/CustomComponents/SalesSummeryBody.js